import { createReducer } from "@reduxjs/toolkit";
import { adminRetrievePendingActions } from "./retrieve-admin-pending-actions";
import type { AdminPendingActionsVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<AdminPendingActionsVM> = {
  fetching: "idle",
  data: {
    hasActions: false,
    fundingRequestsToReview: { pendingCount: 0 },
    fundingRequestsToSubmitToFunder: { pendingCount: 0 },
    teacherPayoutsToPay: { pendingCount: 0 },
    standardTeacherPayoutsToPay: { pendingCount: 0 },
    studentRefundsToProcess: { pendingCount: 0 },
    providerBatchInvoicesToProcess: { pendingCount: 0 },
    teacherBatchInvoicesToProcess: { pendingCount: 0 },
    collaborationRequestsToReview: { pendingCount: 0 },
    batchEnrollmentCandidatesToReview: { pendingCount: 0 },
    trainingInvoicesToProcess: { pendingCount: 0 },
    externalProviderRequestsToReview: { pendingCount: 0 },
    externalProviderPaymentsToApprove: { pendingCount: 0 },
  },
};

export const adminPendingActionsRetrievalReducer = createReducer<RetrievalState<AdminPendingActionsVM>>(initialState, builder => {
  builder.addCase(adminRetrievePendingActions.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrievePendingActions.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrievePendingActions.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
